import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvErrorMessage from '../atoms/OvErrorMessage';
import { StagingSubmitError } from '../../../common/model/type/video-staging.types';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvVideoStagingSubmitErrorProps {
  error: StagingSubmitError | null;
  detail: string | null;
}

const OvVideoStagingSubmitError: FC<OvVideoStagingSubmitErrorProps> = ({
  error,
  detail,
}) => {
  const { t } = useTranslation();

  switch (error) {
    case null:
      return null;

    case 'failed':
      return (
        <div role="alert">
          <OvErrorMessage message={t('videos.staging.createFailed')} />
          {detail && <Detail>{detail}</Detail>}
        </div>
      );

    case 'unknown':
      return (
        <div role="alert">
          <OvErrorMessage message={t('videos.staging.createUnknown')} />
        </div>
      );

    default: {
      const unhandledError: never = error;

      return unhandledError;
    }
  }
};

export default OvVideoStagingSubmitError;

const Detail = styled.p`
  margin: 0.25rem 0 0;
  font-size: ${Variables.fontSizes.SMALL};
  color: ${Colours.OV_CHARCOAL};
`;
